import React, { createContext, useEffect } from "react";

import CheckRoute from "./routecheck";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./Pages/Desktop/Common/Login/Login";
import Settings from "./Pages/Desktop/Broker/Settings/Settings";
import Modules from "./Pages/Desktop/Broker/Settings/CustomisationSettings/Modules/Modules";
import Templates from "./Pages/Desktop/Broker/Settings/CustomisationSettings/Templates/Templates";
import SettingModulesForm from "./Pages/Desktop/Broker/Settings/SettingModulesForm/SettingModulesForm";
import AddNewContact from "./Pages/Desktop/Broker/Contacts/AddNewContact/AddNewContact";
// import AddNewQuotes from "./Pages/Desktop/Broker/Quotes/AddNewQuotes/AddNewQuotes";
import ContactDetail from "./Pages/Desktop/Broker/Contacts/ContactDetail/ContactDetail";
import AddNewQuotes from "./Pages/Desktop/Broker/Quotes/AddNewQuotes/AddNewQuotes";
import TaskManagement from "./Pages/Desktop/Broker/TaskManagement/TaskManagement";
import QuoteDetails from "./Pages/Desktop/Broker/Quotes/QuoteDetails/QuoteDetails";
// import Currencies from "./Pages/Desktop/Broker/Settings/MainSettingMenu/Currencies";
import AddNewClient from "./Pages/Desktop/Broker/Clients/AddNewClient/AddNewClient";
import ClientDetails from "./Pages/Desktop/Broker/Clients/ClientDetails/ClientDetails";
import TaskDetail from "./Pages/Desktop/Broker/TaskManagement/TaskDetail/TaskDetail";
import CustomModules from "./Pages/Desktop/Broker/CustomModules/CustomModules";
import BulkUploadPage from "./Pages/Desktop/Broker/BulkUpload/BulkUploadPage";
import MapFields from "./Pages/Desktop/Broker/BulkUpload/MapFields/MapFields";
import MapFieldsConfirmation from "./Pages/Desktop/Broker/BulkUpload/MapFieldsConfirmation/MapFieldsConfirmation";
import BulkUploadList from "./Pages/Desktop/Broker/BulkUpload/BulkUploadList/BulkUploadList";
import EmployeeDetails from "./Pages/Desktop/Broker/Employees/EmployeeDetails/EmployeeDetails";
import HomeEmployer from "./Pages/Desktop/Employer/HomeEmployer/HomeEmployer";
import Home from "./Pages/Desktop/Employee/Home/Home";
import HomeBroker from "./Pages/Desktop/Broker/HomeBroker/HomeBroker";
import EditOrganisationDetails from "./Pages/Desktop/Broker/Settings/OrganisationSettings/OrganisationDetails/EditOrganisationDetails/EditOrganisationDetails";
import VoluntaryDetails from "./Pages/Desktop/Broker/ProductConfig/VoluntaryPlans/VoluntaryDetails/VoluntaryDetails";
import AddVoluntaryPlan from "./Pages/Desktop/Broker/ProductConfig/VoluntaryPlans/AddVoluntaryPlan/AddVoluntaryPlan";
import OrganisationDetails from "./Pages/Desktop/Broker/Settings/OrganisationSettings/OrganisationDetails/OrganisationDetails";
import InsurerDetails from "./Pages/Desktop/Broker/ProductConfig/Insurers/AddNewInsurer/InsurerDetails/InsurerDetails";
import AddNewInsurer from "./Pages/Desktop/Broker/ProductConfig/Insurers/AddNewInsurer/AddNewInsurer";
// import PolicyDetails from "./Pages/Desktop/Employee/Policywallet/PolicyDetails/PolicyDetails";
import EditPersonalDetails from "./Pages/Desktop/Broker/Settings/GeneralSettings/PersonalSettings/EditPersonalDetails/EditPersonalDetails";
import AddNewPolicy from "./Pages/Desktop/Broker/Policies/AddNewPolicy/AddNewPolicy";
import PolicyDetail from "./Pages/Desktop/Broker/Policies/PolicyDetail/PolicyDetail";
import AddNewEmployee from "./Pages/Desktop/Broker/Employees/AddNewEmployee/AddNewEmployee";
import NewEmployee from "./Pages/Desktop/Employer/Employees/AddNewEmployee/NewEmployee";
import EmpDetails from "./Pages/Desktop/Employer/Employees/EmployeeDetails/EmpDetails";
import EmployerSettings from "./Pages/Desktop/Employer/Settings/EmployerSettings";
import SettingModulesFormm from "./Pages/Desktop/Employer/Settings/SettingModulesForm/SettingModulesFormm";
import PolicyDetailView from "./Pages/Desktop/Employer/Policies/PolicyDetailView/PolicyDetailView";
import Users from "./Pages/Desktop/Broker/Settings/UserAndControl/Users/Users";
import CreateUsers from "./Pages/Desktop/Broker/Settings/UserAndControl/CreateUsers/CreateUsers";
import CreateRole from "./Pages/Desktop/Broker/Settings/UserAndControl/CreateRole/CreateRole";
import CreateBranch from "./Pages/Desktop/Broker/Settings/OrganisationSettings/Branches/CreateBranch/CreateBranch";
import EditBranch from "./Pages/Desktop/Broker/Settings/OrganisationSettings/Branches/EditBranch/EditBranch";
import EditCreateUser from "./Pages/Desktop/Broker/Settings/UserAndControl/EditCreateUser/EditCreateUser";
import EditCreateRole from "./Pages/Desktop/Broker/Settings/UserAndControl/EditCreateRole/EditCreateRole";
import { ALL_ROUTES } from "./Routes/all_routes";
import ClaimAssistantDetail from "./Pages/Desktop/Broker/Claimassistant/ClaimAssistantDetail/ClaimAssistantDetail";
import EndorsementDetail from "./Pages/Desktop/Broker/Endorsement/EndorsementDetail/EndorsementDetail";
import EndorsementDetailEmployer from "./Pages/Desktop/Employer/Endorsement/EndorsementDetailEmployer/EndorsementDetailEmployer";
import ClaimAssistantDetailEmployer from "./Pages/Desktop/Employer/Claimassistant/ClaimAssistantDetailEmployer/ClaimAssistantDetailEmployer";
import Riskmap from "./Pages/Desktop/Employeev2/Riskmap/Riskmap";
import GroupHealthPolicyEmpV2 from "./Pages/Desktop/Employeev2/PolicyWallet/GroupHealthPolicy/GroupHealthPolicyEmpV2";
import InsurancePolicyDetails from "./Pages/Desktop/Employeev2/PolicyWallet/InsurancePolicyDetail/InsurancePolicyDetail";
import PolicyWallet from "./Pages/Desktop/Employeev2/PolicyWallet/PolicyWallet";
import HomeEmployees from "./Pages/Desktop/Employeev2/HomeEmployees/HomeEmployees";
import TpaDetails from "./Pages/Desktop/Broker/ProductConfig/Tpa/AddNewTpa/TpaDetails/TpaDetails";
import EndorsementDetailMemberAddition from "./Pages/Desktop/Broker/Endorsement/EndorsmentMemberAddition/EndorsmentMemberAddition";
import EndorsementDetailMemberDeletion from "./Pages/Desktop/Broker/Endorsement/EndorsementDetailMemberDeletion/EndorsementDetailMemberDeletion";
import EndorsementDetailNomineeDetails from "./Pages/Desktop/Broker/Endorsement/EndorsementDetailNomineeDetails/EndorsementDetailNomineeDetails";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  const add_dark_theme = () => {
    const isDark = localStorage.getItem("theme") === "dark";
    if (isDark) {
      document.body.classList.add("theme-dark");
    } else {
      document.body.classList.remove("theme-dark");
    }
  };

  useEffect(() => {
    add_dark_theme();
  }, []);

  return (
    <>
      {/* <CheckRoute /> */}

      <BrowserRouter>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        <Routes>
          {/* <Route path="*" element={<HomeEmployer />} /> */}
          <Route path="/home" element={<Home />} />
          <Route path="/homeemployer" element={<HomeEmployer />} />
          <Route path="/homebroker" element={<HomeBroker />} />
          <Route path="/customModules" element={<CustomModules />} />
          <Route path="/AddNewContact" element={<AddNewContact />} />
          <Route path="/ContactDetail" element={<ContactDetail />} />
          <Route path="/ClaimAssistantDetail" element={<ClaimAssistantDetail />} />
          <Route path="/ClaimAssistantDetailEmployer" element={<ClaimAssistantDetailEmployer />} />
          <Route path="/EndorsementDetail" element={<EndorsementDetail />} />
          <Route path="/EndorsementDetailMemberAddition" element={<EndorsementDetailMemberAddition />} />
          <Route path="/EndorsementDetailMemberDeletion" element={<EndorsementDetailMemberDeletion />} />
          <Route path="/EndorsementDetailNomineeDetails" element={<EndorsementDetailNomineeDetails />} />
          <Route path="/EndorsementDetailEmployer" element={<EndorsementDetailEmployer />} />
          <Route path="/Settings" element={<Settings />} />
          <Route path="/Modules" element={<Modules />} />
          <Route path="/Templates" element={<Templates />} />
          <Route path="/SettingModuleForm" element={<SettingModulesForm />} />
          {/* <Route path="/AddNewQuotes" element={<AddNewQuotes />} /> */}
          <Route path="/AddNewQuotes" element={<AddNewQuotes />} />
          <Route path="/QuoteDetails" element={<QuoteDetails />} />
          <Route path="/AddNewClient" element={<AddNewClient />} />
          <Route path="/ClientDetails" element={<ClientDetails />} />
          <Route path="/EmployeeDetails" element={<EmployeeDetails />} />
          <Route path="/VoluntaryDetails" element={<VoluntaryDetails />} />
          <Route path="/AddVoluntaryPlan" element={<AddVoluntaryPlan />} />
          <Route path="/InsurerDetails" element={<InsurerDetails />} />
          <Route path="/TpaDetails" element={<TpaDetails />} />
          <Route path="/OrganisationDetails" element={<OrganisationDetails />} />
          <Route path="/AddNewInsurer" element={<AddNewInsurer />} />
          {/* <Route path="/PolicyDetails" element={<PolicyDetails />} /> */}
          <Route path="/TaskManagement" element={<TaskManagement intiateClaim={false} />} />
          <Route path="/TaskDetail" element={<TaskDetail />} />
          <Route path="/EditOrganisationDetails" element={<EditOrganisationDetails />} />
          <Route path="/AddNewPolicy" element={<AddNewPolicy />} />
          <Route path="/PolicyDetail" element={<PolicyDetail />} />
          <Route path={ALL_ROUTES.BULK_UPLOAD_PAGE} element={<BulkUploadPage />} />
          <Route path={ALL_ROUTES.MAP_FIELDS} element={<MapFields />} />
          <Route path="/AddNewEmployee" element={<AddNewEmployee />} />
          <Route path={ALL_ROUTES.MAP_FILED_CONFIRMATION} element={<MapFieldsConfirmation />} />
          <Route path={ALL_ROUTES.BULK_UPLOAD_LIST} element={<BulkUploadList />} />
          <Route path="/home-employee/*" element={<HomeEmployees />} />
          <Route path="/policy-wallet" element={<PolicyWallet />} />
          <Route path="/GroupHealthPolicy" element={<GroupHealthPolicyEmpV2 />} />
          <Route path="/EditOrganisationDetails" element={<EditOrganisationDetails />} />
          <Route path="/EditPersonalDetails" element={<EditPersonalDetails />} />
          <Route path="/NewEmployee" element={<NewEmployee />}></Route>
          <Route path="/EmployeeDetail" element={<EmpDetails />}></Route>
          <Route path="/EmployerSettings" element={<EmployerSettings />} />
          <Route path="/SettingModulesFormm" element={<SettingModulesFormm />} />
          <Route path="/PolicyDetailView" element={<PolicyDetailView />} />
          <Route path="/CreateUsers" element={<CreateUsers />} />
          <Route path="/CreateRole" element={<CreateRole />} />
          <Route path="/CreateBranch" element={<CreateBranch />} />
          <Route path="/EditBranch" element={<EditBranch />} />
          <Route path="/EditCreateUser" element={<EditCreateUser />} />
          <Route path="/EditCreateRole" element={<EditCreateRole />} />
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
